import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};
    if (REQUIRED(values.merchantId)) {
        errors.merchantId = 'Please select merchantId';
    }

    if (REQUIRED(values.adjustmentType)) {
        errors.adjustmentType = 'Please Select Adjustment Type';
    }

    if (REQUIRED(values.adjustmentCategory)) {
        errors.adjustmentCategory = 'Please Select Adjustment Category';
    }

    if (REQUIRED(values.merchantTxnId)) {
        errors.merchantTxnId = 'Please enter Merchant Txn Id';
    }

    if (
        values.adjustmentCategory &&
        (values.adjustmentCategory === 'MANUAL_REFUND' ||
            values.adjustmentCategory === 'CHARGEBACK_REVERSAL' ||
            values.adjustmentCategory === 'CHARGEBACK') &&
        REQUIRED(values.txnReferenceId)
    ) {
        errors.txnReferenceId = 'Please enter Txn Reference Id';
    }

    if (REQUIRED(values.merchantAdjAmount)) {
        errors.merchantAdjAmount = 'Please Enter adjustment amount';
    }
    if (values.merchantAdjAmount && values.merchantAdjAmount < 1) {
        errors.merchantAdjAmount =
            'Please Enter adjustment amount greater than or equals to one';
    }

    return errors;
};

export default validate;
